/* eslint-disable no-unused-vars */
/* eslint-disable arrow-body-style */
import React, { useState, useEffect, useRef } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody, CardHeader, Button, Alert,
  InputGroup,
} from 'reactstrap';
import {
  Table, Tbody, Thead, Tr, Td,
} from 'react-super-responsive-table';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import {
  Formik, Field, Form, ErrorMessage,
} from 'formik';
import * as Yup from 'yup';

import ItemSelector from '../../components/Item/ItemSelector';

import { Can } from '../../utilities/Can';
import { get, post, del } from '../../helpers/api_helper';

function Burnsville(props) {
  const { t } = props;

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const [afterItem, setAfterItem] = useState(null);
  const [sql, setSql] = useState(null);
  const [loading, setLoading] = useState(false);
  const [remoteInventory, setRemoteInventory] = useState(null);

  const beforeRef = useRef(null);

  const getRemoteData = async () => {
    setLoading(true);

    try {
      const response = await get(`/api/burnsville/inventoryByItemId/${afterItem.id}`);

      setRemoteInventory(response);
    } catch (error) {
      toastr.error(t('Error fetching remote data'), t('Error'));
    } finally {
      setLoading(false);
    }
  };

  const generateSql = async () => {
    setLoading(true);
    const beforeIds = beforeRef.current.value.split('\n').map((x) => x.trim()).filter((x) => x.length > 0);
    const beforeIdsSet = new Set(beforeIds);
    const beforeIdsArray = Array.from(beforeIdsSet);
    const beforeIdsString = beforeIdsArray.join(',');

    if (beforeIdsArray.size === 0) {
      toastr.error(t('Please enter before item IDs'), t('Error'));
      return;
    }

    if (afterItem === null) {
      toastr.error(t('Please select an after item'), t('Error'));
      return;
    }

    const remotes = await Promise.all(beforeIdsArray.map(async (id) => {
      const response = await get(`/api/burnsville/inventoryByItemId/${id}`);
      return response;
    }));

    const remoteIds = remotes.map((x) => x.stock_id);
    const remoteIdsSet = new Set(remoteIds);
    const remoteIdsArray = Array.from(remoteIdsSet);
    const remoteIdsString = remoteIdsArray.join('\',\'');

    setLoading(false);

    const sqlstr = `UPDATE \`kit_item\` SET \`stock_id\` = '${remoteInventory.stock_id}' WHERE \`stock_id\` IN('${remoteIdsString}');`;

    setSql(sqlstr);
  };

  useEffect(() => {
    if (afterItem !== null) {
      getRemoteData();
    }
  }, [afterItem]);

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xxl="7">
            <Card>
              <CardHeader className="bg-transparent border-bottom">{t('Convert Kit Items on DZ')}</CardHeader>
              <CardBody>
                <p className="mb-1">{t('Edit the items of kits on DZ to point to the new item\'s stock id instead')}</p>
                <p className="text-danger">{t('This edits ALL kits that contain a before item!')}</p>
                <Row>
                  <Col md="4">
                    <h6>{t('Before (BASE item) Item IDs')}</h6>
                    <textarea ref={beforeRef} className="form-control" rows="5" placeholder={t('One ID per line')} />
                  </Col>
                  <Col md="8">
                    <h6>{t('After Item (BASE proxy item)')}</h6>
                    {afterItem === null && (
                      <ItemSelector
                        onSelect={(item) => {
                          setAfterItem(item);
                        }}
                      />
                    )}
                    {afterItem !== null && (
                      <div>
                        <p className="fs-5">
                          {`${afterItem.manufacturer} ${afterItem.part_number}`}
                          {' '}
                          <Button size="sm" color="danger" className="btn-soft-danger" onClick={() => { setAfterItem(null); }}>
                            <span className="mdi mdi-close-thick" />
                          </Button>
                        </p>

                        {remoteInventory !== null && (
                          <p className="text-muted">
                            {`${t('Remote Stock ID')}:`}
                            {' '}
                            <strong>{remoteInventory.stock_id}</strong>
                          </p>
                        )}
                      </div>
                    )}
                  </Col>
                </Row>

                {afterItem !== null && remoteInventory !== null && sql === null && (
                  <Button disabled={loading} size="sm" color="primary" className="btn-soft-primary mt-3" onClick={generateSql}>
                    {loading ? t('Loading...') : t('Generate SQL')}
                    {' '}
                    <span className="mdi mdi-arrow-right" />
                  </Button>
                )}

                {sql !== null && (
                  <div className="mt-3">
                    <h6>{t('Generated SQL')}</h6>
                    <textarea className="form-control" rows="10" value={sql} readOnly />
                  </div>
                )}
              </CardBody>
            </Card>

            <Card>
              <CardHeader className="bg-transparent border-bottom">{t('Kit Setup on DZ')}</CardHeader>
              <CardBody>
                <textarea className="form-control" rows="5" placeholder={t('sku[,stock id]')} />

                <Button size="sm" color="primary" className="btn-soft-primary mt-3">
                  {t('Generate SQL')}
                  {' '}
                  <span className="mdi mdi-arrow-right" />
                </Button>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}

Burnsville.defaultProps = {
  t: (x) => (x),
};

Burnsville.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(Burnsville));
